import { render, staticRenderFns } from "./DisplayCitiesCategories.vue?vue&type=template&id=e8855692"
import script from "./DisplayCitiesCategories.vue?vue&type=script&lang=ts"
export * from "./DisplayCitiesCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports